import { fetchWithTimeout, handleError, handleResponseError } from "./handlers";

export const fetchUsers = (token) => {
    return async (dispatch) => {
        const res = await fetchWithTimeout('/users', {
            headers: { 'Authorization': 'Bearer ' + token },
        });
        if(res.ok) {
            const { response, data } = await res.json()
            if(response) dispatch({ type: 'FETCH', users: data })
            else dispatch(handleError(data))
        } else
            dispatch(handleResponseError(res))
    }
}

export const fetchUserDetail = (token, name) => {
    return async (dispatch) => {
        const res = await fetchWithTimeout(`/user/${name}`, {
            headers: { 'Authorization': 'Bearer ' + token },
        });
        if(res.ok) {
            const { response, data } = await res.json()
            if(response) dispatch({ type: 'FETCH', user: data })
            else dispatch(handleError(data))
        } else
            dispatch(handleResponseError(res))
    }
}

export const createUser = (token, user, notify) => {
    return async (dispatch) => {
        const res = await fetchWithTimeout('/user', {
            method: 'PUT',
            headers: { 'Content-Type': 'application/json', 'Authorization': 'Bearer ' + token },
            body: JSON.stringify(user)
        }, notify)

        if(res.ok) {
            const { response, data } = await res.json()
            if(response) dispatch({ type: 'CREATE', user: data })
            else dispatch(handleError(data))
        } else
            dispatch(handleResponseError(res))
    }
}

export const editUser = (token, name, user, notify) => {
    return async (dispatch) => {
        const res = await fetchWithTimeout(`/user/${name}`, {
            method: 'PATCH',
            headers: { 'Content-Type': 'application/json', 'Authorization': 'Bearer ' + token },
            body: JSON.stringify(user)
        }, notify)

        if(res.ok) {
            const { response, data } = await res.json()
            if(response) dispatch({ type: 'EDIT', user: data })
            else dispatch(handleError(data))
        } else
            dispatch(handleResponseError(res))
    }
}

export const deleteUser = (token, name) => {
    return async (dispatch) => {
        const res = await fetchWithTimeout(`/user/${name}`, {
            method: 'DELETE',
            headers: { 'Authorization': 'Bearer ' + token },
        })

        if(res.ok) {
            const { response, data } = await res.json()
            if(response) dispatch({ type: 'DELETE', name })
            else dispatch(handleError(data))
        } else
            dispatch(handleResponseError(res))
    }
}
